import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AssignUserRoutingModule } from './assign-user-routing.module';
import { AssignUserHomeComponent } from './assign-user-home/assign-user-home.component';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { MapProductModule } from '../map-product/map-product.module';
// import { CartographyModule } from '../cartography-module/cartography.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppMaterialModule } from '../app-material-module/app-material.module';
import { CommonModuleModule } from '../common-module/common-module.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MapCommonModule } from '../map-common/map-common.module';
import { AssignUserPopupComponent } from './assign-user-popup/assign-user-popup.component';
import {MatSelectModule} from '@angular/material/select';
import { AssignUserToolComponent } from './assign-user-tool/assign-user-tool.component';
import { LassoToolsComponent } from 'projects/lib-map-common/src/lib/lasso-tool/lasso-tools.component';
import { CommonDragCodeComponent } from 'projects/lib-map-common/src/lib/common-drag-code/common-drag-code.component';
import { MapComponent } from 'projects/lib-map-common/src/lib/map/map.component';



@NgModule({
    declarations: [AssignUserHomeComponent, AssignUserPopupComponent, AssignUserToolComponent],
    imports: [
        CommonModule,
        AssignUserRoutingModule,
        MapCommonModule,
        FlexLayoutModule,
        // CartographyModule,
        CommonModuleModule,
        AppMaterialModule,
        ReactiveFormsModule,
        FormsModule,
        MapProductModule,
        MatSelectModule,
        LassoToolsComponent,
        CommonDragCodeComponent,
        MapComponent
    ],
    providers: [
        {
            provide: STEPPER_GLOBAL_OPTIONS,
            useValue: { displayDefaultIndicatorType: false }
        }
    ],
    exports: [AssignUserHomeComponent, AssignUserToolComponent]
})
export class AssignUserModule { }
